/** `GET /api/v1/mosques/{orgNr}/payment-settings`. Hemmeligheter kommer aldri tilbake, bare siste 4 tegn. */
export interface PaymentSettings {
  stripe?: {
    connected: boolean;
    accountName?: string | null;
    keyLast4?: string | null;
    testMode?: boolean;
  } | null;
  vipps?: {
    connected: boolean;
    clientId?: string | null;
    msn?: string | null;
    keyLast4?: string | null;
    testMode?: boolean;
  } | null;
  serverReady: boolean;
}

export const paymentSettingsUrl = (orgNr: string) =>
  `/api/v1/mosques/${encodeURIComponent(orgNr)}/payment-settings`;

/** «Tilkoblet · …a1b2» */
export const connectedLabel = (last4?: string | null) =>
  last4 ? `Tilkoblet · …${last4}` : "Tilkoblet";

/** Stripe-nøkler vi godtar: begrenset eller hemmelig, live eller test. */
export const isStripeKey = (key: string) =>
  /^(rk|sk)_(live|test)_[A-Za-z0-9]+$/.test(key.trim());
